export default __webpack_public_path__ + "static/media/question.1a718638.png";